import { SortByOptions } from './installation.model';

export class DtMeterInstallationInvoiceDto {
  id: number = 0;
  invoiceId: string = '';
  invoiceDate: string = '';
  vendor: string = '';
  meterPrice: number | null = null;
  numberOfMeters: number | null = null;
  period: string = '';
  repaymentPeriod: number | null = null;
  paidPeriod: number | null = null;
  remainingPeriod: number | null = null;
  monthlyRepaymentAmount: number | null = null;
  amountPaid: number | null = null;
  balance: number | null = null;
  lastPaymentDate: string = '';
  status: string = '';
}

export enum DtMeterInstallationInvoiceStatus {
  Approval = 1,
  Active = 2,
  Completed = 3,
}

export interface DtMeterInstallationInvoicePeriod {
  label: string;
  month: number;
  year: number;
}

export interface DtMeterInstallationInvoiceFilterParams {
  status: DtMeterInstallationInvoiceStatus;
  search: string;
  month: number;
  year: number;
  organizationId: number;
  dateFrom: string | null;
  dateTo: string | null;
  sortBy: SortByOptions;
}

export interface DtMeterInstallationInvoicePageInfo {
  pageInfo: { page: number; pageSize: number };
  filterParams: DtMeterInstallationInvoiceFilterParams;
}

export interface DtMeterInstallationInvoiceInstalledDt {
  id: number;
  installationCategory: string;
  dtName: string;
  dtNumber: string;
  address: string;
  dtType: string;
  rating: string;
  region: string;
  district: string;
  feederName: string;
  meterNumber: string;
  meterMake: string;
  meterPrice: number | null;
  installationDate: string;
}

export interface DtMeterInstallationInvoiceInstalledDtPageInfo {
  invoiceId: number;
  pageInfo: { page: number; pageSize: number };
  search: string;
}

export class DtMeterInstallationInvoiceDetailsDto {
  id: number = 0;
  invoiceId: string = '';
  invoiceDate: string = '';
  vendor: string = '';
  status: string = '';
  totalAmount: number | null = null;
  amountPaid: number | null = null;
  balance: number | null = null;
  repaymentPeriod: number | null = null;
  paidPeriod: number | null = null;
  remainingPeriod: number | null = null;
  monthlyRepaymentAmount: number | null = null;
}
